module.exports = __webpack_public_path__ + "static/case1_allergy_desktop-86dbb345789a6c3f29613bc1e007dba8.png";